import { render, staticRenderFns } from "./PersonAddButton.vue?vue&type=template&id=3db11592&"
import script from "./PersonAddButton.vue?vue&type=script&lang=js&"
export * from "./PersonAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports